import React, { createContext, useContext, useEffect, useState } from 'react';

import { legalsBeam } from '../../assets/beams/legalBeam';
import { meBeam } from '../../assets/beams/meBeam';



import { usePagePopFactory } from './usePopFactory';
import { LoginScreen } from '../Oauth/LoginScreen/LoginScreen';

import { useBeam } from '@randajan/bifrost/client/react';
//import { Order } from '../Subscriptions/Order/Order';

//import { ContactScreen } from '../../pages/Contact/ContactScreen/ContactScreen';

import "./PagePops.scss";
import { Legal } from '../Legals/Legal/Legal';
import { MailMeForm } from '../Profile/_forms/MailMeForm/MailMeForm';
import { AvatarForm } from '../Profile/_forms/AvatarForm/AvatarForm';
import { IdentityForm } from '../Profile/_forms/IdentityForm/IdentityForm';
import { PersonalForm } from '../Profile/_forms/PersonalForm/PersonalForm';
import { PinForm } from '../Profile/_forms/PinForm/PinForm';

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { UnsubscribeForm } from '../Profile/_forms/UnsubscribeForm/UnsubscribeForm';
import { usePop, usePopSelf } from '@randajan/jet-react/dom/modal';
import { page } from '../../assets/bases/page';
import { LocaleForm } from '../Locales/LocaleForm/LocaleForm';
import { Link } from '@randajan/jet-react/dom/link';
import { info } from '@randajan/simple-app/info';
import { Say } from '../../../arc/locale/consts.js';

const PagePopsContext = createContext({});


const InPop = (props)=>{
    const { form:Form } = props;
    const popSelf = usePopSelf();
    const close = _=>popSelf?.down();
    return <Form {...props} onCancel={close} onSaved={close}/>
}

const RegUser = (props)=>{
    const { pops, legals, profile } = props;

    const { avatar, hasPin, alias, isNewbie } = (profile || {});

    const avatarTitle = Say.id("profile", "avatar", "popTitle", avatar ? "change" : "set");
    const pinTitle = Say.id("profile", "pin", "popTitle", hasPin ? "change" : "set");
    const identityTitle = Say.id("profile", "identity", "popTitle", alias ? "edit" : "set");

    const privacy = (Object.fromEntries(legals))?.privacy;

    const privacyLink = privacy && <Link to={privacy.url} target="_blank">{privacy.title}</Link>;


    pops.login = usePagePopFactory(<LoginScreen gdpr={privacyLink}/>, {}, {
        titleId:"oauthLoginScreenCaption",
        pagePath:"hash.sign",
        upAllowed:!profile
    });
    
    pops.avatarForm = usePagePopFactory(<InPop form={AvatarForm} profile={profile}/>, { closeOnBlur:false }, { titleId:avatarTitle, icon:<ImageOutlinedIcon/> });
    pops.identityForm = usePagePopFactory(<InPop form={IdentityForm} profile={profile}/>, { lock:true }, { titleId:identityTitle, icon:<EditOutlinedIcon/> });
    pops.mailMeForm = usePagePopFactory(<InPop form={MailMeForm} profile={profile}/>, { lock:true }, { titleId:"profileMailMePopTitle", icon:<EditOutlinedIcon/> });
    pops.personalForm = usePagePopFactory(<InPop form={PersonalForm} profile={profile}/>, { lock:true }, { titleId:"profilePersonalPopTitle", icon:<EditOutlinedIcon/> });
    pops.pinForm = usePagePopFactory(<InPop form={PinForm} profile={profile}/>, { lock:true }, { titleId:pinTitle, icon:<EditOutlinedIcon/> });

    useEffect(_=>{
        if (isNewbie) { pops.mailMeForm.up(); }
    }, [isNewbie]);

    return null;
}

const UnsubscribePopUp = (props)=>{
    const [ tokenPg ] = page.use("search.unsubscribeToken");
    const pop = usePop({ closeOnBlur:false });

    const token = info.isBuild ? tokenPg.pull() : tokenPg.get();
    useEffect(_=>{
        if (!token) { return; }
        pop.up(<InPop form={UnsubscribeForm} payloadToken={token}/>)
    }, [token]);

    return null;
}

const LocalePopUp = (props)=>{
    const { profile, pops } = props;

    pops.localeForm = usePagePopFactory(<LocaleForm userIsLogged={!!profile}/>, { }, {
        pagePath:"hash.localeForm"
    });

    return null;
}

export const PagePops = (props)=>{

    const { data:profile } = useBeam(meBeam);
    const { data:legals } = useBeam(legalsBeam);
    const [ pops, setPops ] = useState({});
    
    return (
        <PagePopsContext.Provider value={pops}>
            {legals && <RegUser legals={legals} profile={profile} pops={pops}/>}
            <UnsubscribePopUp/>
            <LocalePopUp profile={profile} pops={pops}/>
            {props.children}
        </PagePopsContext.Provider>
    )
}

export const usePagePops = _=>useContext(PagePopsContext);

export const usePagePop = id=>usePagePops()[id];
